import { MUTATION_GROUP } from './constants';
import type { JiraUrlFieldInput } from './types';

export const mutateUrlField = (url: string, fieldId: string): JiraUrlFieldInput => {
	const mutatedValue: JiraUrlFieldInput = {
		fieldId,
		mutationGroup: MUTATION_GROUP,
	};

	mutatedValue.url = url;
	return mutatedValue;
};
